import * as React from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { ProjectConfig } from 'Global';
import Cookies from 'universal-cookie';
import { List } from 'devextreme-react';
import { Button, LinearProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import EmptyElement from './EmptyElement';
import { ApiRequest } from 'GlobalFunctions';

const cookies = new Cookies();

interface IAutocompleteList {
  name: string;
  id: number;
}



export default function AutocompleteWarehouses(props: any) {

  const company_id = cookies.get('company_id');

  const {value, onChange, error} = props;
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  const handleOpenList = () => {
  setOpen(true);
  };


  /*=================================================
    CLIENT AUTOCOMPLETE VARIABLES & FUNCTIONS
    =================================================*/
    interface IProjectList {
      inputValue?: string,
      warehouse_id?: number,
      warehouse_name: string,
    };
    const filter = createFilterOptions<IProjectList>();

    //setClientList
    const [list, setList] = useState<any []>([]);
    const [warehouse, setWarehouse] = useState<IProjectList | null>(null);
    
    useEffect(() => {
      
      loadList();
    }, []);


    const loadList = async () => {
      await ApiRequest({
        url: "/warehouses/list",
        method: "get",
        headers: {
          ltkn: localStorage.getItem("ltkn"),
        },
        query: {
          full_list: true,
        },
        setResponse: (response: any) => {
          setList(response.list);
          setLoading(false);
        },
      });
    }
    /* ================================================= 
    ===================================================*/


    let item_name = "";
    if (list && (value && value!=0)) 
    { 
      item_name = list.find(obj => {
        return obj.warehouse_id === parseInt(value); 
      })
    } 
    
    
  return (
    <>

     {list.length > 0 ? 
     (
      <Autocomplete
        value={item_name}
        onChange={(event, newValue) => {
          if (typeof newValue === 'string') {
            setWarehouse({
              warehouse_name: newValue,
            });
          } else if (newValue && newValue.inputValue) {
            // Create a new value from the user input
            setWarehouse({
              warehouse_name: newValue.inputValue,
            });
          } else {
            setWarehouse(newValue);
            if (newValue?.warehouse_id!=null)
            {
              onChange({
                  target: {
                      value: newValue.warehouse_id.toString(),
                      name: "warehouse_id",
                  }
              })
            }
            else {
              onChange({
                target: {
                    value: "",
                    name: "warehouse_id",
                }
              })
            }
            
          }
          
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          

          return filtered;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        fullWidth
        id="free-solo-with-text-demo"
        options={list}
        getOptionLabel={(option) => {
          // Value selected with enter, right from the input
          if (typeof option === 'string') {
            return option;
          }
          // Add "xxx" option created dynamically
          if (option.inputValue) {
            return option.inputValue;
          }
          // Regular option
          return option.warehouse_name;
        }}
        renderOption={(props, option) => <li className="flex_select" {...props}>
          <div className="flex_option_1">{option.warehouse_name}</div>
        </li>}
        freeSolo
        renderInput={(params) => (
          <TextField 
          {...params} 
          label="Bodega" 
          error={error}
          
          placeholder='Bodega'
          />
        )}
        
      /> 
      )
      :
      (
        <>
        
        <LinearProgress />
        
        </>
      )}
    </>
  );
}
